export default __webpack_public_path__ + "static/footerBg-6ee6d289d1c8022580e3b81d2c6bebf7.jpg";